import React, { Component } from 'react';
import { BASE } from '../api/api'
import Axios from 'axios'
import Slider from "react-slick";
import pdfcover from '../assets/homeevent.jpeg'


class EventReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      annual: '',
      annualpdf: '',
      limit: 9,
      offset: 0,
      next: true,
      prev: false
    }

  }
  //Next/previous click function
  handlePageClick = data => {
    console.log(data, 'offset')
    if (data === 'next' && this.state.next === true) {
      this.setState({
        people: '',
      })
      this.apicall(this.state.offset + this.state.limit)
      this.setState({
        offset: this.state.offset + this.state.limit
      })
    }
    else if (data === 'prev' && this.state.prev === true) {
      this.setState({
        people: '',
      })
      this.setState({
        offset: this.state.offset - this.state.limit
      })
      this.apicall(this.state.offset - this.state.limit)
    }


  };
  topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
  componentWillMount() {
    this.apicall(0)
  }
  //Anuual reports pdf
  apicall(id) {
    this.topFunction();
    if (id <= 0) {
      this.setState({
        prev: false,
      })
    }
    else {
      this.setState({
        prev: true
      })
    }


    Axios(BASE + 'jsonapi/node/events?include=field_event_report&sort=-created', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
      .then((data) => {
        this.setState({
          annual: data.data.data,
          annualpdf: data.data.included ? data.data.included : ''
        })
      })
      .catch((err) => {
        console.log('not found')
      })
  }
  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: this.state.annualpdf !== '' ? window.innerWidth > 800 ? this.state.annualpdf.length >= 5 ? 5 : this.state.annualpdf.length : this.state.annualpdf.length >= 2 ? 2 : this.state.annualpdf.length : 0,
      slidesToScroll: this.state.annualpdf !== '' ? window.innerWidth > 800 ? this.state.annualpdf.length >= 5 ? 5 : this.state.annualpdf.length : this.state.annualpdf.length >= 2 ? 2 : this.state.annualpdf.length : 1,
      autoplay: false,
      autoplaySpeed: 3000,
      arrows: true
    };


    return (
      <div className='articlepage researchdivpage'>

        {/* Annual Rerports */}
        {this.state.annualpdf ? <div className="page-title">
          <div className="title-wrapper">
            <div className="container">
              <h1 className="page-header">Event Reports</h1>
            </div>
          </div>
        </div>
          : ''}
        {this.state.annualpdf ?
          <div className="main-content annualpdf">
            <div className="container">
              <div className="row">
                <div className="region region-content">

                  <div style={{ position: "relative" }} className="view-wiki">
                    <Slider {...settings} >

                      {this.state.annualpdf.map((institute, index) => {
                        return (
                          <div key={index} className="views-row col s6 m3 l3 evereport">

                            <a target="_blank" rel="noopener noreferrer" href={BASE + this.state.annualpdf[index].attributes.uri.url}>
                              <span className="field-content">

                                <div onMouseLeave={() => this.setState({ tooltip: null })} onMouseOver={() => this.setState({ tooltip: this.state.annual[index].attributes.title })} className="img-head">
                                  <img typeof="foaf:Image" src={pdfcover} width="600" height="300" alt="" />
                                  <div className='report-title'>{this.state.annual[index].attributes.title.substring(0, 40)}{this.state.annual[index].attributes.title.length > 40 ? '....' : ''}</div>
                                  {index === 2 && this.state.tooltip && this.state.tooltip.length > 40 ? <div className="evetooltip">{this.state.tooltip}</div> : ''}
                                </div>

                              </span>
                            </a>
                          </div>)
                      })}
                    </Slider>
                  </div>
                </div>
              </div>
            </div>
          </div>
          : ''}
      </div>
    )


  }

}


export default EventReport;
